import {queryLastUnreadMessage} from '../api/chat/index'
import store from '../store/index'
import { Notification } from 'element-ui'
import router from '../router/index'
import themeItem from '../utils/theme_configure/theme.color'

// let noticeNotifyObj
// let msgNotifyObj

export default function showUnreaMsgdNotify () {
  if (!store.state.Auth.token) {
    return
  }
  let params = {
    userId: store.state.Auth.userId,
    userType: 1,
    platformType: themeItem.im_platform_id
  }
  queryLastUnreadMessage(params).then(res => {
    if (res.resultCode === 0) {
      let {noticeMsg, ordinaryMsg} = res.resultData
      // 群发通知是否展示
      let isNoticeShow = Boolean(noticeMsg)
      if (isNoticeShow && !window.noticeNotifyObj) {
        window.noticeNotifyObj = Notification({
          duration: 0,
          dangerouslyUseHTMLString: true,
          showClose: false,
          customClass: 'unread-notify-container',
          offset: 72,
          message: `<div class="message-main">
            <img src="${require('../common/img/system_msg.png')}" alt="">
            <div class="notify-middle">
              <div class="notify-title">群公告消息</div>
              <div class="message-user">${noticeMsg.userNickName}</div>
              <div class="notify-content danhang">${noticeMsg.noticeTitle}</div>
            </div>
            <div class="message-time">${timeHandler(noticeMsg.msgSendTime) || ''}</div>
          </div>`,
          onClick: () => {
            window.noticeNotifyObj.close()
            window.noticeNotifyObj = null
            let urlObj = router.resolve({
              name: 'Chat'
            })
            window.open(urlObj.href)
          }
        })
      }
      if (ordinaryMsg && !window.msgNotifyObj) {
        // 私信
        window.msgNotifyObj = Notification({
          duration: 0,
          dangerouslyUseHTMLString: true,
          showClose: false,
          customClass: 'unread-notify-container',
          offset: isNoticeShow ? 177 : 72,
          message: `<div class="message-main">
            <img src="${require('../common/img/default_avatar.png')}" alt="">
            <div class="notify-middle">
              <div class="notify-title">${ordinaryMsg.userNickName} (ID:${ordinaryMsg.userId})</div>
              <div class="notify-content danhang">${ordinaryMsg.msgType === 1 ? '[图片]' : ordinaryMsg.msgBody}</div>
            </div>
            <div class="message-time">${timeHandler(ordinaryMsg.msgSendTime) || ''}</div>
          </div>`,
          onClick: () => {
            window.msgNotifyObj.close()
            window.msgNotifyObj = null
            let urlObj = router.resolve({
              name: 'Chat',
              query: {
                toUserNickName: ordinaryMsg.userNickName,
                toUserType: 2,
                toUserIdList: [ordinaryMsg.userId]
              }
            })
            window.open(urlObj.href)
          }
        })
      }
    }
  })
}

// 时间格式处理函数
function timeHandler (time) {
  time = time.replace(/-/g, '/')
  let Time = new Date(time)
  let year = Time.getFullYear()
  let month = addZero(Time.getMonth() + 1)
  let day = addZero(Time.getDate())
  let h = addZero(Time.getHours())
  let m = addZero(Time.getMinutes())
  let t = Time.setHours(0, 0, 0, 0)
  if (new Date(time).toDateString() === new Date().toDateString()) {
    // 今天
    return h + ':' + m
  } else if (t - new Date().setHours(0, 0, 0, 0) === -86400000) {
    return '昨天 ' + h + ':' + m
  } else if (t - new Date().setHours(0, 0, 0, 0) === -86400000 * 2) {
    return '前天 ' + h + ':' + m
  } else if (year === new Date().getFullYear()) {
    return month + '-' + day + ' ' + h + ':' + m
  } else {
    return year + '-' + month + '-' + day + ' ' + h + ':' + m
  }
}

// 补0函数
function addZero (num) {
  if (num < 10) {
    return '0' + num
  } else {
    return num
  }
}



// WEBPACK FOOTER //
// ./src/global/showUnreaMsgNotify.js